export const REGION_POLYGON_CLASS = 'region-polygon';
export const NULL_POLYGON_OPTIONS = { stroke: null, fill: null };

export default function polygonOptions(regionType, selected = false, error = false) {
  let classNames = [REGION_POLYGON_CLASS, `${REGION_POLYGON_CLASS}--${regionType}`];
  if (selected) classNames.push(`${REGION_POLYGON_CLASS}--selected`);
  if (error) classNames.push(`${REGION_POLYGON_CLASS}--error`);
  return {
    ...NULL_POLYGON_OPTIONS,
    className: classNames.join(' ')
  };
}
